import React, { useState } from 'react';

// Real logo files (optional): drop a PNG/SVG at /public/clients/<slug>.png and it
// is used automatically. Until then a brand-styled wordmark tile is shown.
const clients = [
  { slug: 'fabindia', name: 'Fabindia', category: 'Retail & Lifestyle', color: '#8a3324', font: "'Plus Jakarta Sans', serif", tracking: '0.02em', weight: 700 },
  { slug: 'nicobar', name: 'nicobar', category: 'Home & Fashion', color: '#1f3d3a', font: "'DM Sans', sans-serif", tracking: '0.22em', weight: 500 },
  { slug: 'miniso', name: 'MINISO', category: 'Lifestyle Products', color: '#e01d2b', font: "'Plus Jakarta Sans', sans-serif", tracking: '0.04em', weight: 800 },
  { slug: 'storeex', name: 'STOREEX 24/7', category: 'Retail Chain', color: '#0f2038', font: "'Plus Jakarta Sans', sans-serif", tracking: '0.06em', weight: 800 },
  { slug: 'kickers', name: 'KICKERS', category: 'Footwear Brand', color: '#b3282d', font: "'Plus Jakarta Sans', sans-serif", tracking: '0.12em', weight: 800 },
  { slug: 'kothari', name: 'KOTHARI', category: 'Business Group', color: '#1b4d89', font: "'Plus Jakarta Sans', serif", tracking: '0.14em', weight: 700 }
];

const ClientTile = ({ client, index }) => {
  const [hasLogo, setHasLogo] = useState(true);

  return (
    <div className="ax-card group flex flex-col rounded-2xl p-5" data-testid={`client-card-${index}`}>
      <div className="flex h-20 items-center justify-center rounded-xl bg-white px-3">
        {hasLogo ? (
          <img
            src={`/clients/${client.slug}.png`}
            alt={`${client.name} logo`}
            onError={() => setHasLogo(false)}
            className="max-h-14 w-auto max-w-full object-contain grayscale transition-all duration-500 group-hover:grayscale-0"
            data-testid={`client-logo-img-${index}`}
          />
        ) : (
          <span
            className="text-center text-[15px] leading-tight sm:text-base"
            style={{
              color: client.color,
              fontFamily: client.font,
              letterSpacing: client.tracking,
              fontWeight: client.weight
            }}
            data-testid={`client-logo-wordmark-${index}`}
          >
            {client.name}
          </span>
        )}
      </div>
      <div className={hasLogo ? 'mt-4 border-t border-slate-100 pt-4' : 'mt-2'}>
        {hasLogo && <p className="ax-display text-sm font-extrabold text-[#0f2038]">{client.name}</p>}
        <p className={`text-xs font-medium text-slate-500 ${hasLogo ? 'mt-0.5' : ''}`}>{client.category}</p>
      </div>
    </div>
  );
};

export const ClientLogoWall = () => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6 lg:gap-6" data-testid="client-logo-wall">
    {clients.map((c, i) => (
      <ClientTile key={c.slug} client={c} index={i} />
    ))}
  </div>
);
